import { Amplify } from 'aws-amplify'

let configured = false

export function configureAmplify (): void {
  if (configured) return

  // TODO: move these to env vars later
  const identityPoolId = 'ap-northeast-1:eae787c7-2909-486d-b635-c2e69f0a6ef1'
  const region = 'ap-northeast-1'

  const hasIdentityPoolId =
    typeof identityPoolId === 'string' && identityPoolId.length > 0
  const hasRegion =
    typeof region === 'string' && region.length > 0

  if (!hasIdentityPoolId || !hasRegion) {
    console.error('Cognito identityPoolId / region is missing')
    return
  }

  const config = {
    Auth: {
      Cognito: {
        identityPoolId,
        region,
        allowGuestAccess: true
      }
    }
  } as const

  // TS types assume you also have a User Pool; you don't.
  // Casting is the sane way out here.
  Amplify.configure(config as any)

  configured = true
}
